<script lang="ts" setup>
const router = useRouter()

const isBannerShowed = ref(true)

const closeCookiesBanner = () => {
  localStorage.setItem('cookiesShowed', 'true')
  isBannerShowed.value = true
}

const goToConfidential = () => {
  closeCookiesBanner()

  router.push('/confidential/')
}

onMounted(() => {
  if (!localStorage.getItem('cookiesShowed')) isBannerShowed.value = false
})
</script>

<template>
  <transition name="height">
    <noindex
      v-if="!isBannerShowed"
      class="cookies"
      data-e2e="the-cookies-banner"
    >
      <div class="cookies__container">
        <div class="cookies__container-description">
          <nuxt-img
            class="cookies__description-icon"
            width="30"
            height="30"
            src="/cookies-icon.svg"
            alt="Мы используем куки"
          />

          <div class="container">
            <div>Пользуясь сайтом, вы соглашаетесь с &nbsp;</div>
            <div
              role="link"
              class="cookies__description-link"
              @click="goToConfidential"
            >
              использованием cookies
            </div>
          </div>
        </div>

        <v-btn variant="text" icon rounded>
          <nuxt-img
            src="/icon-close.svg"
            width="24"
            height="24"
            alt="Закрыть панель cookie"
            class="cookies__container-close"
            @click="closeCookiesBanner"
          />
        </v-btn>
      </div>
    </noindex>
  </transition>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/animations.scss';

.cookies {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 111;
  display: flex;
  justify-content: center;
  width: 100%;
  &__container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    max-width: 768px;
    padding: 16px 20px;
    font-size: 16px;
    font-weight: 600;
    line-height: 19px;
    color: $dark-grey;
    background: $white;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 6px 50px rgba(50, 52, 72, 0.3);

    @include media('<desktop-mini') {
      max-width: 100%;
    }

    @include media('<tablet') {
      font-size: 12px;
      font-weight: 600;
      line-height: 14px;
    }

    &-description {
      display: flex;
      align-items: center;

      .container {
        display: flex;

        @include media('<tablet') {
          display: grid;
        }
      }

      .cookies__description-icon {
        margin-right: 16px;
      }

      .cookies__description-link {
        font-size: 16px;
        font-weight: 600;
        line-height: 19px;
        color: $text-black;
        text-decoration: underline;
        cursor: pointer;

        @include media('<tablet') {
          max-width: 100%;
          font-size: 12px;
          font-weight: 600;
          line-height: 14px;
        }
      }
    }

    .cookies__container-close {
      cursor: pointer;
    }
  }
}
</style>
